// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1w4gK","type":"styles_type__gc9zk","choices":"styles_choices__2vnSB"};